import { render, staticRenderFns } from "./FooterCopyRightArea.vue?vue&type=template&id=eb3ec980&"
import script from "./FooterCopyRightArea.vue?vue&type=script&lang=js&"
export * from "./FooterCopyRightArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports